export const GuardSeverity = {
  Info: 'info',
  Warning: 'warning',
  Error: 'error',
};

export const GuardSeverityLabels = {
  [GuardSeverity.Info]: 'Информация',
  [GuardSeverity.Warning]: 'Предупреждение',
  [GuardSeverity.Error]: 'Ошибка (блокирует сохранение)',
};

export const GuardSeverityColors = {
  [GuardSeverity.Info]: 'blue',
  [GuardSeverity.Warning]: 'orange',
  [GuardSeverity.Error]: 'red',
};

export const GuardSeverityOptions = Object.entries(GuardSeverityLabels)
  .map(([value, label]) => ({ value, label }));

export const GuardTrigger = {
  Save: 'save',
  Manual: 'manual',
  Change: 'change',
};

export const GuardTriggerLabels = {
  [GuardTrigger.Save]: 'При сохранении',
  [GuardTrigger.Manual]: 'По кнопке',
  [GuardTrigger.Change]: 'При правках',
};

export const GuardTriggerOptions = Object.entries(GuardTriggerLabels)
  .map(([value, label]) => ({ value, label }));

export const GuardScope = {
  AllFloors: 'allFloors',
  CurrentFloor: 'currentFloor',
};

export const GuardScopeLabels = {
  [GuardScope.AllFloors]: 'Все этажи',
  [GuardScope.CurrentFloor]: 'Только открытый этаж',
};

export const GuardScopeOptions = Object.entries(GuardScopeLabels)
  .map(([value, label]) => ({ value, label }));

export const GuardOwnerType = {
  Customer: 'customer',
  CrmApartment: 'crm_apartment',
  CrmPlan: 'crm_plan',
};

export const GuardOwnerField = {
  [GuardOwnerType.Customer]: 'customers',
  [GuardOwnerType.CrmApartment]: 'crm_apartments',
  [GuardOwnerType.CrmPlan]: 'crm_plans',
};

export const GuardTriggerDescriptions = {
  [GuardTrigger.Save]: 'Запускается перед сохранением планировки.',
  [GuardTrigger.Manual]: 'При открытии панели проверок в конструкторе и по кнопке «Проверить».',
  [GuardTrigger.Change]: 'Пересчитывается автоматически, пока панель проверок открыта.',
};

/**
 * Виды исправления замечания — функции context.fix, которыми гард описывает исправление, в порядке инструкции.
 * Вид задаёт, что человек увидит справа в конструкторе.
 */
export const GuardFixAction = {
  ReplaceAll: 'replaceAll',
  Provide: 'provide',
  FloorHeight: 'floorHeight',
  RoomType: 'roomType',
  Objects: 'objects',
  Place: 'place',
};

export const GuardFixActionLabels = {
  [GuardFixAction.ReplaceAll]: 'Заменить везде',
  [GuardFixAction.Provide]: 'Поставить нужное',
  [GuardFixAction.FloorHeight]: 'Задать высоту этажа',
  [GuardFixAction.RoomType]: 'Сменить тип комнаты',
  [GuardFixAction.Objects]: 'Удалить или заменить',
  [GuardFixAction.Place]: 'Расставить по площади',
};

/** Виды, у которых есть автоисправление; поставить нужное и расставить по площади человек решает сам. */
export const GuardAutoFixActions = [
  GuardFixAction.ReplaceAll,
  GuardFixAction.FloorHeight,
  GuardFixAction.RoomType,
  GuardFixAction.Objects,
];

/** Включён ли гард — для фильтра и метки в списке. */
export const GuardStatus = {
  Enabled: 'enabled',
  Disabled: 'disabled',
};

export const GuardStatusLabels = {
  [GuardStatus.Enabled]: 'Включён',
  [GuardStatus.Disabled]: 'Выключен',
};

export const GuardStatusOptions = Object.entries(GuardStatusLabels)
  .map(([value, label]) => ({ value, label }));

export const GuardApplyScope = {
  All: 'all',
  Selected: 'selected',
};
